<template>
    <div class="container-action-button">
        <BaseButton @click="onEditDeliveryForm" buttonText="" title="Modifier le bon de livraison">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'search']" />
            </template>
        </BaseButton>
    </div>
</template>

<script>
    import BaseButton from '../../components/Base/BaseButton.vue';
    import * as Vue from "vue";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

    export default {
        name: 'ListDeliveryFormsActionButtonsRenderer',
        components: {
            BaseButton: Vue.shallowRef(BaseButton),
            FontAwesomeIcon: Vue.shallowRef(FontAwesomeIcon)
        },
        methods: {
            onEditDeliveryForm() {
                this.params.context.componentParent.editDeliveryForm(this.params.data);
            }
        }
    }        
</script>